import React, { ReactElement } from 'react'
import styled from '@emotion/styled'
import { Providers } from 'src/layout/providers'
import { ContentLoader, PathSwitchLoader } from 'src/layout/content-loader'
import { Modals } from 'src/layout/modals'
import { Growler } from 'src/components/growl'
import { ErrorBoundary } from 'src/components/errors/error-boundary'
import { RefreshChecker } from 'src/components/refresh-checker'
import { Colors, printStyle } from 'src/components/theme'
import dynamic from 'next/dynamic'
import { MobileDownload } from 'src/components/mobile-download'
// import { ExpiryChecker } from 'src/components/expiry-checker'
import { VerticalToolbar } from 'src/layout/vertical-toolbar'
import { Box } from '@mui/material'

type MainLayoutProps = {
  children?: React.ReactNode
}

export const MainLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color: #f5f5f5;
`

const print = printStyle`
  overflow: unset;
  background: white;
`
export const MainLayoutContent = styled.div`
  position: relative;
  flex: 1;
  width: 100vw;
  height: calc(100vh - 60px);
  display: flex;
  overflow: hidden;
  background-color: #f5f5f5;
  ${print}
`

const DynamicAnalytics = dynamic<any>(() => import('src/components/analytics').then((x) => x.Analytics), { ssr: false })

const LayoutVerticalNav = (props: { children: React.ReactNode }) => {
  return (
    <Box display="flex" minHeight="100vh">
      {/* Sidebar */}
      <Box width="80px" bgcolor={Colors.neutral950} display="flex" flexDirection="column">
        <VerticalToolbar />
      </Box>
      {/* Main Content */}
      <Box overflow={'hidden'} flex={1} display="flex" flexDirection="column" bgcolor={Colors.bgWhite}>
        <PathSwitchLoader />
        <ErrorBoundary>
          <React.Suspense fallback={<ContentLoader />}>
            {props.children}
            <Modals />
            <Growler />
          </React.Suspense>
        </ErrorBoundary>
      </Box>
    </Box>
  )
}

export const MainLayout = (props: MainLayoutProps) => {
  const { children } = props

  return (
    <Providers>
      <MobileDownload>
        {/* <ExpiryChecker> */}
        <RefreshChecker>
          <LayoutVerticalNav>{children}</LayoutVerticalNav>
        </RefreshChecker>
        {/* </ExpiryChecker> */}
      </MobileDownload>
      <DynamicAnalytics />
    </Providers>
  )
}

export const getMainLayout = (page: ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}
